import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
const ModalVideo = dynamic(() => import("react-modal-video"), { ssr: false });
import { PlayButtonWithRipple } from "@modules/study/common/play_btn_with_ripple";
import styles from "./study_video.module.scss";
import { getAssets } from "@unisearch/helpers";
import Image from "next/legacy/image";

export const StudyVideo = (props) => {
  const { pageData } = props;
  const [isOpen, setOpen] = useState(false);
  const [videoSrc, setVideoSrc] = useState("");
  const [videoType, setVideoType] = useState("");
  const [embededCode, setEmbededCode] = useState("");

  useEffect(() => {
    if (pageData?.videoType === "upload") {
      setVideoSrc(pageData?.videoupload?.src);
      setVideoType("custom");
      setEmbededCode("");
    } else {
      setVideoSrc("");
      setVideoType("youtube");
      setEmbededCode(pageData?.embedCode);
    }
  }, [pageData?.videoType]);

  return (
    <section className={styles.section_study_video}>
      <div className="container">
        <div className={styles.study_video_wrapper}>
          <div className={styles.video_area}>
            <Image
              layout="responsive"
              width={850}
              height={450}
              blurDataURL={getAssets(
                "assets/images/image_placeholder_big.webp"
              )}
              placeholder="blur"
              className={styles.featured_image}
              src={
                pageData?.featureImage?.src ||
                getAssets("assets/images/image_placeholder_big.webp")
              }
              alt={pageData?.featureImage?.alt || "Feature Image"}
            />

            <PlayButtonWithRipple onClick={() => setOpen(true)} />

            {videoType === "custom" ? (
              <ModalVideo
                channel={videoType}
                autoplay
                isOpen={isOpen}
                // videoId={`${pageData?.embedCode}`}
                url={videoSrc}
                // url={}
                onClose={() => setOpen(false)}
              />
            ) : (
              <ModalVideo
                channel={videoType}
                autoplay
                isOpen={isOpen}
                // videoId={`${pageData?.embedCode}`}
                videoId={embededCode}
                // url={}
                onClose={() => setOpen(false)}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StudyVideo;
